<script setup>
import { ref } from 'vue';
const competitionData = ref(null);
</script>

<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.MATCH.SHOW_COMPETITION_DETAIL"
    :handler="(data) => { competitionData = data; $refs.dialog.show(); }"
  />
  <DialogComponent ref="dialog" type="fullscreen" hideCloseButton noInnerPadding>
    <div class="h-full pb-24 overflow-auto bg-gray-50" v-if="competitionData">
      <!-- Header fixed -->
      <div class="bg-secondary fixed top-0 w-full z-10">
        <div class="mobile-status-padding"></div>
        <div class="px-4 h-24 flex items-center gap-4">
          <button class="w-8 h-8" @click="$refs.dialog.hide()">
            <ColorImg src="/images/icons/arrow-up.svg" class="w-full h-full bg-white -rotate-90 opacity-70" alt="Back" />
          </button>
          <div class="flex-1 text-center text-white text-2xl uppercase font-bold truncate">
            {{ competitionData?.category?.name || '-' }}
          </div>
          <div class="w-8"></div>
        </div>
      </div>
      <div class="mobile-status-padding"></div>

      <!-- Content -->
      <div class="p-6 pt-28">
        <!-- Calendar icon + title -->
        <div class="flex items-center gap-3 mb-6">
          <div class="w-12 h-12 rounded-2xl bg-secondary-500 flex items-center justify-center">
            <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
            </svg>
          </div>
          <h1 class="text-2xl font-bold text-gray-800">Calendrier</h1>
        </div>

        <!-- Matches list -->
        <div class="flex flex-col gap-4" v-if="competitionData.matches?.length">
          <MatchesPresentation
            v-for="(match, i) in competitionData.matches"
            :key="i"
            :match="match"
            @click="$bus.emit($constants.EVENTS.MATCH.SHOW_MATCH_DETAIL, match)"
          />
        </div>

        <!-- Empty state -->
        <div v-else class="flex flex-col items-center justify-center py-16">
          <div class="w-20 h-20 rounded-full bg-gray-100 flex items-center justify-center mb-4">
            <svg class="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.172 16.172a4 4 0 015.656 0M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
            </svg>
          </div>
          <div class="text-gray-500 font-medium">Aucun match disponible</div>
        </div>
      </div>

      <!-- Bouton Déposer bloqué en bas -->
      <div class="fixed bottom-0 left-0 right-0 p-4 bg-white border-t border-gray-200">
        <button
          @click.stop="$bus.emit($constants.EVENTS.SERVICES.START, { group: 'recharges', option: 'fund' })"
          class="w-full flex items-center justify-center gap-3 py-4 px-6 text-white font-bold text-lg rounded-xl bg-primary-500 hover:bg-primary-600"
        >
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
          </svg>
          Déposer
        </button>
      </div>
    </div>
  </DialogComponent>
</template>
